module.exports = __webpack_public_path__ + "static/media/icon_schedule_phone_gray.c997f285.svg";